<template>
  <div>
    <h2>Admin Panel - Approve Bookings</h2>

     <!-- ✅ Show Add Shop Button for Super Admins -->
     <button v-if="isSuperAdmin" @click="goToAddShop">
      ➕ Add Shop
    </button>
    <button v-if="isSuperAdmin" @click="goToUserManage">
      ➕ Add UserManage
    </button>
    

    <label>Select Shop:</label>
    <select v-if="isSuperAdmin" v-model="selectedShop" @change="fetchBookings">
      <option v-for="shop in shops" :key="shop.id" :value="shop.id">{{ shop.name }}</option>
    </select>
    <p v-else><strong>Managing Shop:</strong> {{ selectedShopName }}</p>

    <div v-for="(booking, index) in bookings" :key="index" class="booking-card">
      <p><strong>Name:</strong> {{ booking.name }}</p>
      <p><strong>Date:</strong> {{ booking.date }}</p>
      <p><strong>Time:</strong> {{ booking.time }}</p>
      <p><strong>Status:</strong> 
        <span :class="{ 'approved': booking.isApproved, 'pending': !booking.isApproved }">
          {{ booking.isApproved ? "✅ Approved" : "⏳ Pending" }}
        </span>
      </p>
      <img v-if="booking.paymentReceipt" :src="booking.paymentReceipt" width="200" alt="Payment Receipt" />
      <button v-if="!booking.isApproved" @click="approveBooking(booking.id)">Approve</button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { auth,database,getDoc,doc,db } from "../firebase"; // Import the listener
import {  onAuthStateChanged } from "firebase/auth";// getIdToken

export default {
  data() {
    return {
      userorigin: null, // ✅ Store logged-in user
      user: {
        email: "",
        role: "",
        uid:"",
        shopId: "",
        userInfo: "",
      },
      userType: "",
      userInfo: "",
      selectedShop: "", // Automatically set based on admin's shop
      selectedShopName: "",
      shops: [],
      bookings: [],
      isSuperAdmin: false,
      adminEmail: "", // Replace with logged-in user's email
    };
  },
  methods: {
    async initializeFirebase() {
    this.auth = auth;
    this.database = database;
    },
    async checkAuthState() {
      onAuthStateChanged(this.auth, async (user) => {
        if (user) {
          this.user.userInfo = user.displayName;
          this.user.uid = user.uid;
          this.user.email = user.email ;
          this.adminEmail = user.email;
          console.log("email "+user.email);
          console.log("displayName "+ user.displayName);
          console.log("uid "+ user.uid);
          console.log("uid "+ user.accessToken);

          this.userorigin = user; // ✅ Store user authentication object
      
          // ✅ Get user role & shop from ID token
          const idTokenResult = await user.getIdTokenResult(true);
          console.log("🛠️ User Role:", idTokenResult.claims.role || "Not Assigned");
          console.log("🛠️ Assigned Shop:", idTokenResult.claims.shopId || "None");

          this.user.role = idTokenResult.claims.role || "";
          this.user.shopId = idTokenResult.claims.shopId || null;
          this.user.email = user.email;

          await this.fetchUserType();
          
        } else {  
          console.log("User not authenticated. Redirecting to login...");
          this.$router.push("/"); // Use Vue Router instead of window.location.href
        }
      });
    },
    async fetchUserType() {
      try {
        this.loading = true;
        if (!this.user.email) {
          throw new Error("❌ No logged-in user.");
        }

        // ✅ Query Firestore Collection
        const userRef = doc(db, "users", this.user.email);
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
          const userData = userSnap.data();
          console.log("✅ Firestore Document Data:", userData); // ✅ Logs the entire object
          console.table(userData); // 📊 Nicely formatted table in Console

          this.user.role = userData.role;
          console.log("role "+  this.user.role);
          this.user.shopId = userData.shopId || null;
          console.log("shopId "+  this.user.shopId);
          if ( this.user.role === "super_admin"){
            this.adminEmail = this.user.email;
            this.isSuperAdmin = true;
          }
        } else {
          throw new Error("❌ No user data found.");
        }
      } catch (error) {
        console.error("❌ Error fetching user type:", error);
        this.errorMessage = "❌ Failed to fetch user data.";
      } finally {
        this.loading = false;
      }
    },
  

    async fetchAdminAccount() {
      try {
        const response = await axios.get(`https://getadminaccount-u32waniu4a-df.a.run.app?email=${this.adminEmail}`);
        if (response.data) {
          this.selectedShop = response.data.shopId;
          this.isSuperAdmin = response.data.role === "super_admin";

          if (this.isSuperAdmin) {
           await  this.fetchShops();
          } else {
           await  this.fetchBookings();
          }
        } else {
          alert("❌ Unauthorized: No admin account found.");
        }
      } catch (error) {
        console.error("❌ Error fetching admin account:", error);
      }
    },
    async fetchShops() {
      try {
        const response = await axios.get("https://getshops-u32waniu4a-df.a.run.app");
        this.shops = response.data;
        this.fetchBookings();
      } catch (error) {
        console.error("❌ Error fetching shops:", error);
      }
    },
    async fetchBookings() {
      if (!this.selectedShop) return;
      try {
        const response = await axios.get(
          `https://getshopbookings-u32waniu4a-df.a.run.app?shopId=${this.selectedShop}&email=${this.adminEmail}`
        );
        this.bookings = response.data;
      } catch (error) {
        console.error("❌ Error fetching bookings:", error);
      }
    },
    async approveBooking(bookingId) {
      try {
        await axios.post("https://approvebooking-u32waniu4a-df.a.run.app", {
          bookingId,
        });
        alert("✅ Booking Approved!");
        this.fetchBookings(); // Refresh bookings
      } catch (error) {
        console.error("❌ Error approving booking:", error);
      }
    },
    // ✅ Redirect to Add Shop Panel
    goToAddShop() {
      this.$router.push("/add-shop");
    },
    goToUserManage() {
      this.$router.push("/user-manage");
    },
  },
  async mounted() {
    await this.initializeFirebase();
    await this.checkAuthState();
    await this.fetchAdminAccount();
  },
};
</script>

<style scoped>
h2 {
  text-align: center;
  margin-bottom: 20px;
}

.booking-card {
  border: 1px solid #ccc;
  padding: 10px;
  margin: 10px auto;
  max-width: 400px;
  background: #f9f9f9;
}

button {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  width: 100%;
}

button:hover {
  background-color: #218838;
}

.approved {
  color: green;
  font-weight: bold;
}

.pending {
  color: red;
  font-weight: bold;
}
</style>
